// مصدر واحد للتحكّم بإظهار الأسعار/المبالغ حسب الدور.
// الأدوار التي ترى الأسعار تُضبط من **لوحة التحكّم** (system_settings.price_visible_roles)
// وتُحمَّل في localStorage عند تسجيل الدخول. الافتراضيّ الاحتياطيّ: مدير(1) · مالك(3) · محاسب(7).
export const PRICE_VISIBLE_ROLE_IDS = [1, 3, 7];

function configuredRoleIds() {
  const csv = localStorage.getItem('price_visible_roles');
  if (!csv) return PRICE_VISIBLE_ROLE_IDS;
  const roles = csv.split(',').map((x) => parseInt(x, 10)).filter((n) => Number.isInteger(n) && n > 0);
  return roles.length ? roles : PRICE_VISIBLE_ROLE_IDS;
}

export function canViewPrices() {
  const roleId = Number(localStorage.getItem('role_id') || 0);
  return configuredRoleIds().includes(roleId);
}

export default canViewPrices;
